import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/about/xselly_logo_340.png')
const LOGO = assets.images.about.xsellyLogo

const XSellyLogo = (props: ICommonLogoOptionalProps) => {
  return <CommonLogo source={LOGO} {...props} />
}

export default XSellyLogo
